import React, { useEffect, useCallback } from 'react';
import { AsyncProjectBuilderDrawer as ProjectBuilderDrawer } from '@atlassian/jira-servicedesk-project-builder/src/async.tsx';
import { SHOW_PROJECT_BUILDER_QUERY_PARAM } from '@atlassian/jira-servicedesk-project-builder/src/common/constants.tsx';
import { useQueryParam, useRouter } from '@atlassian/react-resource-router';
import { useProjectBuilder } from '../../services/use-project-builder/index.tsx';
/**
 * Manages the visibility and state of the project builder drawer based on query parameters.
 * It controls when to show the project builder drawer, especially after a condition
 * involving specific query parameters is met, ensuring it's not displayed for auto-created
 * projects or outside the project queues page. This component also handles the drawer's
 * open state and its closure action.
 */
const ProjectBuilderWithQueryParam = () => {
	const [projectBuilderQueryParam, setProjectBuilderQueryParam] = useQueryParam(
		SHOW_PROJECT_BUILDER_QUERY_PARAM,
	);
	// if it's a first, auto created, JSM project as part of X-flow from JSW
	const [autoCreateFirstJsmProject] = useQueryParam('autoCreateFirstJsmProject');
	const [{ route }] = useRouter();
	const [state, actions] = useProjectBuilder();
	const onClosed = useCallback(() => {
		actions.hideProjectBuilder();
	}, [actions]);

	useEffect(() => {
		// Show project builder only on project queues page, but not on auto-created projects
		if (
			projectBuilderQueryParam === 'true' &&
			autoCreateFirstJsmProject !== '1' &&
			(route.name === 'servicedesk-queues-landing' ||
				route.name === 'servicedesk-getting-started-page')
		) {
			actions.showProjectBuilder();

			setProjectBuilderQueryParam(undefined);
		}
	}, [
		actions,
		autoCreateFirstJsmProject,
		projectBuilderQueryParam,
		route.name,
		setProjectBuilderQueryParam,
	]);
	if (state.isProjectBuilderOpen) {
		return <ProjectBuilderDrawer isOpenInitial onClosed={onClosed} />;
	}
	return null;
};
export default ProjectBuilderWithQueryParam;
